import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextual", "use"];
import { ConfirmDialog } from '../ConfirmDialog/ConfirmDialog';
import AbstractModal from '../AbstractModal/AbstractModal';
import { PanelContext } from '../../context/PanelContext';
import { ModalTransition } from '../Modal/ModalTransition';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const inPanelContext = {
  inPanel: false,
  inModal: true
};
export const ConfirmModal = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      contextual = false,
      use = 'default'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    children
  } = rest;
  return /*#__PURE__*/_jsx(PanelContext.Provider, {
    value: inPanelContext,
    children: /*#__PURE__*/_jsx(AbstractModal, Object.assign({}, rest, {
      _contextual: contextual,
      use: use,
      ModalDialog: ConfirmDialog,
      Transition: ModalTransition,
      componentName: "Modal",
      ref: ref,
      children: children
    }))
  });
});